// Google maps api key
export const GOOGLE_MAPS_KEY = "AIzaSyCZwE1uxt5Y3KEmbYlTGDfU-bod9pg21_E";

// Loader options
export const LOADER_OPTIONS = {
  backgroundColor: "#555357",
  canCancel: true,
  color: "#345AAD",
  isFullPage: true,
  loader: "bars",
};

// Regex
export const PHONE_REGEX =
  /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
